if (!customElements.get('store-slider')) {
  customElements.define(
    'store-slider',
    class StoreSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector(`.slider-${this.sectionId}`);
        if (!this.slider) return;

        this.prevArrow = this.querySelector(`#SliderArrowPrev-${this.sectionId}`) || document.querySelector(`#SliderArrowPrev-${this.sectionId}`);
        this.nextArrow = this.querySelector(`#SliderArrowNext-${this.sectionId}`) || document.querySelector(`#SliderArrowNext-${this.sectionId}`);
        this.initSlider();
      }

      get sectionId() {
        return this.dataset.sectionId;
      }
      get slidesperView() {
        return Number(this.dataset.slides);
      }

      get slidesQuantity() {
        return this.querySelectorAll('.splide__slide').length;
      }

      initSlider() {
        const options = {
          slidesPerView: 1.2,
          slidesPerMove: 1,
          spaceBetween: 12,
          pagination: false,
          watchSlidesProgress: true,
          slidesOffsetAfter: 12,
          watchOverflow: true,
          navigation: {
            nextEl: this.nextArrow,
            prevEl: this.prevArrow,
          },
          breakpoints: {
            560: {
              slidesPerView: this.slidesperView - 1.7,
            },
            750: {
              slidesPerView: this.slidesperView - 1,
              slidesOffsetAfter: 40,
            },
            1024: {
              slidesPerView: this.slidesperView - 0.75,
            },
            1280: {
              slidesPerView: this.slidesperView,
              slidesOffsetAfter: 40,
            },
          },
        };

        const slider = new Swiper(this.slider, options);
      }
    }
  );
}
